function ativaClass() {
  // Seleciona BreadCrumb
  let breadItens = document.querySelectorAll(".breadItem");

  // Seleciona Ultimo BradCrumb
  let pag = breadItens[breadItens.length - 1].innerHTML;

  // Seleciona Lista de Categorias
  let categoriaBlog = document.querySelectorAll(".categoriaBlog");

  // Seleciona Categoria Todos / Blog
  let catTodos = document.querySelector("#catTodos");

  // compara Categoria com BreadCrumb e ativa CSS
  categoriaBlog.forEach((categoriaB) => {
    console.log(categoriaB.innerHTML + pag);
    if (categoriaB.innerHTML == pag) {
      categoriaB.classList.add("active");
    } else if (pag == "Blog") {
      catTodos.classList.add("active");
    }
  });
}
